<template>
  <div>
    <div ref="container">
      <a-affix :offsetTop="0">
        <a-page-header
          style="border-bottom: 1px solid rgb(235, 237, 240); background: #fff"
          class="mb-5 px-0"
          title='Edit Voucher'
          @back="() => $router.push('/discounts')"
        >
        </a-page-header>
      </a-affix>
    </div>
    <VoucherForm
      :value="data"
      :statusVoucher="statusVoucher"
    />
  </div>
</template>

<script>
import VoucherForm from '../../../components/Voucher/Form'
import moment from 'moment'

export default {
  components: {
    VoucherForm,
  },
  mounted () {
    this.$store.dispatch('discounts/GETVOUCHERDETAIL', { id: this.$route.params.id })
      .then(({ data }) => {
        this.data = data
        this.statusVoucher = this.checkStatusVoucher(data.validity.from, data.validity.until)
      })
  },
  data () {
    return {
      data: {},
      statusVoucher: '',
    }
  },
  methods: {
    changeDateFormat (value) {
      return moment.unix(value).format('YYYY-MM-DD HH:mm:ss')
    },

    checkStatusVoucher (from, until) {
      /** Check expired */
      if (moment(this.changeDateFormat(until)).isBefore(moment())) {
        return 'expired'
      }
      /** Check Coming Soon */
      if (moment(this.changeDateFormat(from)).isAfter(moment())) {
        return 'coming soon'
      }
      /** Check Running Voucher */
      if (moment().isBetween(this.changeDateFormat(from), this.changeDateFormat(until))) {
        return 'running'
      }
    },
  },
}
</script>
